<template>
    <div class="PayYearlyAuthor p-3 shadow">
        <!-- Button trigger modal -->
        <button type="button" class="d-none" id="PayYearlyAuthorModalBtn" data-toggle="modal"
            data-target="#PayYearlyAuthorModalShow">
            Launch static backdrop modal
        </button>

        <div class="modal fade" id="PayYearlyAuthorModalShow" data-backdrop="static" data-keyboard="false" tabindex="-1"
            aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">پرداخت مبلغ عضویت</h5>
                    </div>
                    <div class="modal-body lh-lg">
                        <p>
                            مشاور عزیز, مبلغ عضویت سالانه شما پرداخت نشده است.
                        </p>
                        <p>
                            لطفا جهت پرداخت مبلغ از طریق دکمه زیر اقدام فرمایید.
                        </p>
                        <p class="PayYearlyAuthorModalMsg text-danger font-weight-bold"></p>
                    </div>
                    <div class="modal-footer" style="direction: ltr;">
                        <button type="button" class="btn btn-primary PayYearlyAuthorModalPayBtn" @click="PayYearlyAuthor">پرداخت از درآمد من</button>
                        <button type="button" class="btn btn-secondary PayYearlyAuthorModalCloseBtn" data-dismiss="modal">بستن</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'PayYearlyAuthor',
    methods: {
        PayYearlyAuthor() {
            axios.get('author-yearly-price/')
                .then(response => {
                    document.querySelector('.PayYearlyAuthorModalMsg').innerHTML    = '';
                    if (response.status === 201) {
                        document.querySelector('.PayYearlyAuthorModalCloseBtn').click();
                    } else {
                        document.querySelector('.PayYearlyAuthorModalMsg').innerHTML    = response.data.msg;
                        document.querySelector('.PayYearlyAuthorModalPayBtn').classList.add('d-none');
                    }
                })
                .catch(e => this.codeEM = e.response.data, this.codeE = true )
        }
    }
}
</script>
